var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewAgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.582,
    height: 17.961,
    viewBox: "0 0 19.582 17.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#0a0a0a;}.b{stroke:#ebb546;stroke-linecap:round;stroke-width:0.5px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1603.115 -1295)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3049.32 438.039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4663.829 866.733)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M142.478,234.815h-3.11a2.542,2.542,0,0,0-2.539,2.539V242.5a.508.508,0,0,0,.508.508h7.173a.508.508,0,0,0,.508-.508v-5.141A2.542,2.542,0,0,0,142.478,234.815Z",
    transform: "translate(-136.829 -234.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4664.87 860)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.168,38.84a3.053,3.053,0,1,0,3.054,3.054A3.057,3.057,0,0,0,170.168,38.84Z",
    transform: "translate(-167.114 -38.84)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1616.115 1296) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 11,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.25,
    y: 0.25,
    width: 10.5,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 1)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1618.115 1299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 11,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.25,
    y: 0.25,
    width: 10.5,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 2,
    rx: 1,
    transform: "translate(1621.115 1299.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(1615.615 1296.5) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAgent);
export default __webpack_public_path__ + "static/media/newAgent.6f01af0ddd89af3260caf037e33c2e50.svg";
export { ForwardRef as ReactComponent };